<template>
  <div class="pt-4">
    <ContentWrapperControl>
      <SettingCardControl v-bind:title="lang('lbl_0000255')">
        <SettingCardItemControl
          v-bind:value="date_of_birth"
          v-bind:title="lang('lbl_0000105')"
          v-bind:href="date_of_birth_href"
          icon="papsi_date_of_birth.svg"
          :show_border="false"
        />
      </SettingCardControl>
      <SettingCardControl v-bind:title="lang('lbl_0000067')">
        <SettingCardItemControl
          v-bind:value="tin"
          v-bind:title="lang('lbl_0000098')"
          v-bind:href="tin_href"
          icon="papsi_tax.svg"
          :show_border="false"
        />
      </SettingCardControl>
    </ContentWrapperControl>
  </div>
</template>

<script>
import ContentWrapperControl from "./../../components/controls/ContentWrapperControl.vue";
import SettingCardControl from "./../../components/controls/SettingCardControl.vue";
import SettingCardItemControl from "./../../components/controls/SettingCardItemControl.vue";
import mixin from "./../../mixin.js";
import datetime from "date-and-time";

export default {
  mixins: [mixin],
  components: {
    ContentWrapperControl,
    SettingCardControl,
    SettingCardItemControl,
  },
  data() {
    return {
      tin: null,
      tin_href: "/settings/info/tin",
      date_of_birth: null,
      date_of_birth_href: "/settings/info/date-of-birth",
    };
  },
  mounted() {
    this.$emit("checkauth");
    this.$emit("nofooter", false);
    this.$emit("shownavbar", {
      title: this.lang("lbl_0000081"),
      show: true,
      back: true,
    });

    this.tin = this.$store.state.info.tin;
    this.date_of_birth = this.formatDate(this.$store.state.info.date_of_birth);

    if (this.tin != null) {
      this.tin_href = null;
    }

    if (this.date_of_birth != null) {
      this.date_of_birth_href = null;
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      return datetime.format(new Date(date), "MM/DD/YYYY");
    },
  },
};
</script>
